import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";

export const COUNTRY_QUERY_KEY = ["country"];
export const VIEW_COUNTRY_QUERY_KEY = ["view-country"];

export interface CreateCountryPayload {
  code: string;
  name: string;
  status: number;
}

export interface UpdateCountryPaylod extends CreateCountryPayload {}

export const countryService = {
  createCountry: async (payload: CreateCountryPayload) => {
    return requestWithRefresh(async () => {
      const response = await api.post("api/country", payload);
      return response.data;
    });
  },
  updateCountry: async (code: string, payload: UpdateCountryPaylod) => {
    const response = await api.put(`api/country/${code}`, payload);
    return response.data;
  },
  getCountryByCode: async (code: string) => {
    return requestWithRefresh(async () => {
      const response = await api.get(`api/country/${code}`);
      return response.data;
    });
  },
  getAllCountry: async () =>
    requestWithRefresh(() =>
      api
        .get(`api/country`, { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),

  getAllViewCountry: async () =>
    requestWithRefresh(() =>
      api
        .get("api/view-country", { headers: getAuthHeaders() })
        .then((res) => res.data),
    ),

  toggleStatus: async (code: string) =>
    requestWithRefresh(() =>
      api
        .put(
          `api/country/${code}/toggle-status`,
          {},
          { headers: getAuthHeaders() },
        )
        .then((res) => res.data),
    ),
};
